// @ts-nocheck
// SVG preview renderer (no Shopify, minimal DOM).
(() => {
  window.Cfg = window.Cfg || {};

  const Preview = {
    createSvg() {
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      svg.setAttribute("data-rb-preview-svg", "");
      svg.setAttribute("width", "100%");
      svg.setAttribute("height", "100%");
      svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
      svg.setAttribute("role", "img");
      const translations = window.CfgTranslations && window.CfgTranslations.strings;
      svg.setAttribute("aria-label", translations && translations.planPreview ? translations.planPreview : "Plan Preview");
      return svg;
    },

    clear(svg) {
      while (svg.firstChild) svg.removeChild(svg.firstChild);
    },

    _getScale(svg) {
      const s = svg && svg._rbScale;
      return Number.isFinite(s) && s > 0 ? s : 1;
    },

    _getOpeningSeg1Effective(o, sideLabel) {
      if (!o) return NaN;
      const key = sideLabel ? `${String(sideLabel).toLowerCase()}1EffectiveIn` : "a1EffectiveIn";
      const v = o[key] ?? o.a1EffectiveIn ?? o.a1In;
      return Number(v);
    },

    _pxToUser(svg, px) {
      const scale = Preview._getScale(svg);
      return px / scale;
    },

    line(svg, { x1, y1, x2, y2, stroke = "#000", widthPx = 1, dashPx = null } = {}) {
      const el = document.createElementNS("http://www.w3.org/2000/svg", "line");
      el.setAttribute("x1", String(x1));
      el.setAttribute("y1", String(y1));
      el.setAttribute("x2", String(x2));
      el.setAttribute("y2", String(y2));
      el.setAttribute("stroke", stroke);
      el.setAttribute("stroke-width", String(Preview._pxToUser(svg, widthPx)));
      el.setAttribute("stroke-linecap", "butt");
      if (dashPx && Array.isArray(dashPx) && dashPx.length >= 2) {
        const onU = Preview._pxToUser(svg, dashPx[0]);
        const offU = Preview._pxToUser(svg, dashPx[1]);
        el.setAttribute("stroke-dasharray", `${onU} ${offU}`);
      }
      svg.appendChild(el);
      return el;
    },

    text(svg, { x, y, value, sizePx = 12, fill = "#000", anchor = "start" } = {}) {
      const el = document.createElementNS("http://www.w3.org/2000/svg", "text");
      el.setAttribute("x", String(x));
      el.setAttribute("y", String(y));
      el.setAttribute("font-size", String(Preview._pxToUser(svg, sizePx)));
      el.setAttribute("fill", fill);
      el.setAttribute("text-anchor", anchor);
      el.textContent = String(value);
      svg.appendChild(el);
      return el;
    },

    textLines(svg, { x, y, lines, sizePx = 12, fill = "#000", anchor = "start", lineGap = 1.1 } = {}) {
      if (!Array.isArray(lines) || lines.length === 0) return null;
      const el = document.createElementNS("http://www.w3.org/2000/svg", "text");
      el.setAttribute("x", String(x));
      el.setAttribute("y", String(y));
      el.setAttribute("font-size", String(Preview._pxToUser(svg, sizePx)));
      el.setAttribute("fill", fill);
      el.setAttribute("text-anchor", anchor);
      for (let i = 0; i < lines.length; i++) {
        const tspan = document.createElementNS("http://www.w3.org/2000/svg", "tspan");
        tspan.setAttribute("x", String(x));
        tspan.setAttribute("dy", i === 0 ? "0" : `${lineGap}em`);
        tspan.textContent = String(lines[i]);
        el.appendChild(tspan);
      }
      svg.appendChild(el);
      return el;
    },

    polygon(svg, { points, fill = "#ccc", stroke = "none", strokeWidthPx = 0 } = {}) {
      const el = document.createElementNS("http://www.w3.org/2000/svg", "polygon");
      const pointsStr = Array.isArray(points) ? points.map((p) => `${p.x},${p.y}`).join(" ") : "";
      el.setAttribute("points", pointsStr);
      el.setAttribute("fill", fill);
      el.setAttribute("stroke", stroke);
      if (strokeWidthPx > 0) {
        el.setAttribute("stroke-width", String(Preview._pxToUser(svg, strokeWidthPx)));
      }
      svg.appendChild(el);
      return el;
    },

    render(svg, plan, { mode = "full", layout = null, catalog = null } = {}) {
      Preview.clear(svg);
      if (!plan || !Array.isArray(plan.vertices) || plan.vertices.length < 2) return;

      // Fit viewBox
      const { minX, minY, maxX, maxY } = plan.bbox || { minX: 0, minY: 0, maxX: 1, maxY: 1 };
      const w = Math.max(1, maxX - minX);
      const h = Math.max(1, maxY - minY);
      let pad = Math.max(10, Math.max(w, h) * 0.12);
      let vbX = minX - pad;
      let vbY = minY - pad;
      let vbW = w + pad * 2;
      let vbH = h + pad * 2;
      svg.setAttribute("viewBox", `${vbX} ${vbY} ${vbW} ${vbH}`);

      // Compute scale (px per user-unit) so strokes/text stay readable at large lengths.
      // Force a layout read to ensure dimensions are available.
      void svg.offsetHeight; // Force reflow
      const rect = svg.getBoundingClientRect();
      const svgWidth = rect.width || (svg.clientWidth || 420);
      const svgHeight = rect.height || (svg.clientHeight || 420);
      const sx = svgWidth > 0 ? svgWidth / vbW : 1;
      const sy = svgHeight > 0 ? svgHeight / vbH : 1;
      svg._rbScale = Math.max(1e-6, Math.min(sx, sy));

      // If labels/lines would be cropped, expand the viewBox padding.
      const extraPad = Preview._pxToUser(svg, 90);
      if (extraPad > pad + 1e-3) {
        pad = extraPad;
        vbX = minX - pad;
        vbY = minY - pad;
        vbW = w + pad * 2;
        vbH = h + pad * 2;
        svg.setAttribute("viewBox", `${vbX} ${vbY} ${vbW} ${vbH}`);
        const sx2 = svgWidth > 0 ? svgWidth / vbW : 1;
        const sy2 = svgHeight > 0 ? svgHeight / vbH : 1;
        svg._rbScale = Math.max(1e-6, Math.min(sx2, sy2));
      }

      const STROKE_MAIN_PX = 2;
      const STROKE_OPENING_PX = 1.5;
      const TEXT_SIDE_PX = 24;
      const TEXT_SEG_PX = 18;
      const LABEL_OFFSET_PX = 32;
      const sideSummaryMap = new Map((layout?.sides || []).map((s) => [s.label, s]));
      const getPanelsForLabel = (label, segLabel) => {
        const summary = sideSummaryMap.get(label);
        if (!summary) return [];
        if (Array.isArray(summary.segments) && summary.segments.length) {
          const seg = summary.segments.find((s) => String(s.label) === String(segLabel));
          return Array.isArray(seg?.panels) ? seg.panels : [];
        }
        if (String(label) === String(segLabel)) return Array.isArray(summary.panels) ? summary.panels : [];
        return [];
      };

      const getOpeningSeg1Effective = (obj, sideLbl) => Preview._getOpeningSeg1Effective(obj, sideLbl);

      const edgeDistanceIn = typeof plan.edgeDistanceIn === "number" && Number.isFinite(plan.edgeDistanceIn) && plan.edgeDistanceIn > 0 ? plan.edgeDistanceIn : 0;
      const showDetails = mode !== "shape-only";

      // Draw each side (and openings when present)
      const sides = plan.sideSegments || {};
      const openingBySide = plan.openingBySide || {};

      // Draw offset lines (gray bands) if edge distance is set
      // Lines are drawn parallel to each side, only where deductions occur
      if (showDetails && edgeDistanceIn > 0 && Object.keys(sides).length > 0) {
        Preview._drawOffsetLines(svg, plan.shape, sides, edgeDistanceIn);
      }

      const labels = Object.keys(sides);
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        const seg = sides[label];
        const p0 = seg.p0;
        const p1 = seg.p1;
        if (!p0 || !p1) continue;

        const dx = p1.x - p0.x;
        const dy = p1.y - p0.y;
        const L = Math.hypot(dx, dy) || 1;
        const ux = dx / L;
        const uy = dy / L;
        const nx = -uy;
        const ny = ux;

        const o = openingBySide[label];
        const a1Eff = getOpeningSeg1Effective(o, label);
        if (showDetails && o && Number.isFinite(o.x1In) && Number.isFinite(a1Eff)) {
          const a1 = a1Eff;
          const x1 = o.x1In;
          const startD = Math.max(0, Math.min(L, a1));
          const endD = Math.max(0, Math.min(L, a1 + x1));

          const os = { x: p0.x + ux * startD, y: p0.y + uy * startD };
          const oe = { x: p0.x + ux * endD, y: p0.y + uy * endD };
          const lenA1 = startD;
          const lenA2 = Math.max(0, L - endD);

          // A1 segment (only draw base line when no panels)
          const a1Panels = getPanelsForLabel(label, `${label}1`);
          if (lenA1 > 1e-6 && a1Panels.length === 0) {
            Preview.line(svg, { x1: p0.x, y1: p0.y, x2: os.x, y2: os.y, stroke: "#000", widthPx: STROKE_MAIN_PX });
          }
          const isDoor = o.type === "door";
          if (isDoor) {
            // Opening segment (dashed) only for doors
            Preview.line(svg, {
              x1: os.x,
              y1: os.y,
              x2: oe.x,
              y2: oe.y,
              stroke: "#aaa",
              widthPx: STROKE_OPENING_PX,
              dashPx: [1, 1],
            });
          }
          // A2 segment (only draw base line when no panels)
          const a2Panels = getPanelsForLabel(label, `${label}2`);
          if (lenA2 > 1e-6 && a2Panels.length === 0) {
            Preview.line(svg, { x1: oe.x, y1: oe.y, x2: p1.x, y2: p1.y, stroke: "#000", widthPx: STROKE_MAIN_PX });
          }

          if (o.type === "door" && o.hinge && o.swing) {
            const hingeAtStart = String(o.hinge).endsWith("1");
            const hingePoint = hingeAtStart ? os : oe;
            const swingInside = o.swing === "inside";
            const alongX = hingeAtStart ? ux : -ux;
            const alongY = hingeAtStart ? uy : -uy;
            const leftNx = alongY;
            const leftNy = -alongX;
            const rightNx = -alongY;
            const rightNy = alongX;
            const hingeInside = hingeAtStart ? swingInside : !swingInside;
            const swingNx = hingeInside ? leftNx : rightNx;
            const swingNy = hingeInside ? leftNy : rightNy;
            const angleRad = (10 * Math.PI) / 180;
            const dirX = alongX * Math.cos(angleRad) + swingNx * Math.sin(angleRad);
            const dirY = alongY * Math.cos(angleRad) + swingNy * Math.sin(angleRad);
            const doorLen = Number.isFinite(o.x1In) ? o.x1In : Preview._pxToUser(svg, 28);
            Preview.line(svg, {
              x1: hingePoint.x,
              y1: hingePoint.y,
              x2: hingePoint.x + dirX * doorLen,
              y2: hingePoint.y + dirY * doorLen,
              stroke: "#000",
              widthPx: STROKE_MAIN_PX,
            });
          }

          const idx = o.index || 1;
          // Labels: e.g. A1 / X1 / A2
          const off = Preview._pxToUser(svg, LABEL_OFFSET_PX);
          const segA1Mid = { x: (p0.x + os.x) / 2 + nx * off, y: (p0.y + os.y) / 2 + ny * off };
          const segXMid = { x: (os.x + oe.x) / 2 + nx * off, y: (os.y + oe.y) / 2 + ny * off };
          const segA2Mid = { x: (oe.x + p1.x) / 2 + nx * off, y: (oe.y + p1.y) / 2 + ny * off };
          if (lenA1 > 1e-6) {
            Preview.text(svg, { x: segA1Mid.x, y: segA1Mid.y, value: `${label}1`, sizePx: TEXT_SEG_PX });
          }
          if (isDoor) {
            Preview.text(svg, { x: segXMid.x, y: segXMid.y, value: `X${idx}`, sizePx: TEXT_SEG_PX });
          }
          if (lenA2 > 1e-6) {
            Preview.text(svg, { x: segA2Mid.x, y: segA2Mid.y, value: `${label}2`, sizePx: TEXT_SEG_PX });
          }
        } else {
          const sidePanels = getPanelsForLabel(label, label);
          if (sidePanels.length === 0) {
            Preview.line(svg, { x1: p0.x, y1: p0.y, x2: p1.x, y2: p1.y, stroke: "#000", widthPx: STROKE_MAIN_PX });
          }
        }

        // Draw dimension lines: outside raw length, inside effective length
        // Skip inner effective length marker for straight shapes
        if (showDetails && (Number.isFinite(seg.rawLengthIn) || Number.isFinite(seg.effectiveLengthIn))) {
          const isStraight = plan.shape === "straight";
          Preview._drawDimensionLines(svg, {
            p0,
            p1,
            label,
            sideIndex: i,
            sideCount: labels.length,
            rawLengthIn: seg.rawLengthIn,
            effectiveLengthIn: isStraight ? NaN : seg.effectiveLengthIn,
            edgeDistanceIn,
            shape: plan.shape,
          });
        }
      }

      // Draw corner offset indicators
      if (showDetails && edgeDistanceIn > 0) {
        Preview._drawCornerOffsets(svg, sides, edgeDistanceIn);
      }

      if (showDetails && layout && layout.sides && Object.keys(sides).length > 0) {
        Preview._drawPanelGapsAndSpigots(svg, plan, layout, catalog, STROKE_MAIN_PX);
      }
    },

    _buildSpigotMap(catalog) {
      const map = new Map();
      const list = (arr) => (Array.isArray(arr) ? arr : []);
      for (const v of list(catalog?.glassStandard)) {
        const id = v?.variant_id ?? v?.variantId;
        if (!id) continue;
        const count = Number(v?.metafields?.spigots_count);
        map.set(Number(id), Number.isFinite(count) ? count : 0);
      }
      for (const v of list(catalog?.glassPerforated)) {
        const id = v?.variant_id ?? v?.variantId;
        if (!id) continue;
        const count = Number(v?.metafields?.spigots_count);
        map.set(Number(id), Number.isFinite(count) ? count : 0);
      }
      return map;
    },

    _drawSquare(svg, { x, y, sizePx = 6, fill = "#000" } = {}) {
      const size = Preview._pxToUser(svg, sizePx);
      const half = size / 2;
      const el = document.createElementNS("http://www.w3.org/2000/svg", "rect");
      el.setAttribute("x", String(x - half));
      el.setAttribute("y", String(y - half));
      el.setAttribute("width", String(size));
      el.setAttribute("height", String(size));
      el.setAttribute("fill", fill);
      svg.appendChild(el);
      return el;
    },

    _drawPanelGapsAndSpigots(svg, plan, layout, catalog, panelStrokePx) {
      const spigotMap = Preview._buildSpigotMap(catalog);
      const openingBySide = plan.openingBySide || {};
      const sideSummaryMap = new Map((layout.sides || []).map((s) => [s.label, s]));

      for (const [label, seg] of Object.entries(plan.sideSegments || {})) {
        const summary = sideSummaryMap.get(label);
        if (!summary) continue;
        const segments = Array.isArray(summary.segments) && summary.segments.length ? summary.segments : [summary];
        const p0 = seg.p0;
        const p1 = seg.p1;
        const dx = p1.x - p0.x;
        const dy = p1.y - p0.y;
        const L = Math.hypot(dx, dy) || 1;
        const ux = dx / L;
        const uy = dy / L;

        for (const segSummary of segments) {
          const segLabel = segSummary.label || label;
          let startDist = 0;
          if (String(segLabel).endsWith("2")) {
            const o = openingBySide[label];
            const a1Eff = Number(Preview._getOpeningSeg1Effective(o, label));
            const doorLen = Number(o?.x1In ?? 0);
            startDist = Number.isFinite(a1Eff) && Number.isFinite(doorLen) ? a1Eff + doorLen : 0;
          }

          const panels = Array.isArray(segSummary.panels) ? segSummary.panels : [];
          const endGapStart = Number(segSummary.endGapStart) || 0;
          const endGapEnd = Number(segSummary.endGapEnd) || 0;
          const gapIn = Number(segSummary.gapIn) || 0;
          const segLen = Number.isFinite(segSummary.effectiveLengthIn) ? Number(segSummary.effectiveLengthIn) : 0;

          let cursor = startDist + endGapStart;

          for (let i = 0; i < panels.length; i++) {
            const panel = panels[i];
            const panelLen = Number(panel.lengthIn);
            if (!Number.isFinite(panelLen) || panelLen <= 0) {
              continue;
            }
            const panelStart = cursor;
            const panelEnd = cursor + panelLen;
            const px1 = p0.x + ux * panelStart;
            const py1 = p0.y + uy * panelStart;
            const px2 = p0.x + ux * panelEnd;
            const py2 = p0.y + uy * panelEnd;
            const isCustomPanel =
              panel?.customPerforated === true ||
              panel?.source === "panel_custom_perforated" ||
              panel?.source === "panel_custom_standard" ||
              (panel?.needsPerforation === true && (panel?.variantId == null || panel?.variantId === undefined));
            const strokeRed = isCustomPanel || panel?.needsPerforation === true;
            Preview.line(svg, {
              x1: px1,
              y1: py1,
              x2: px2,
              y2: py2,
              stroke: strokeRed ? "#c0392b" : "#000",
              widthPx: panelStrokePx,
            });
            const spigotCount = isCustomPanel ? 2 : (spigotMap.get(Number(panel.variantId)) || 0);
            const fractions =
              spigotCount === 1
                ? [0.5]
                : spigotCount === 2
                ? [1 / 4, 3 / 4]
                : spigotCount === 3
                ? [1 / 6, 3 / 6, 5 / 6]
                : [];
            for (const f of fractions) {
              const d = cursor + panelLen * f;
              const x = p0.x + ux * d;
              const y = p0.y + uy * d;
              Preview._drawSquare(svg, { x, y, sizePx: 6, fill: "#000" });
            }

            cursor += panelLen + gapIn;
          }
        }
      }
    },

    // Draws grey lines parallel to each side, with stroke-width equal to the offset.
    // Lines are drawn only along the portions where deductions occur (at corners).
    _drawOffsetLines(svg, shape, sideSegments, edgeDistanceIn) {
      if (!sideSegments || typeof sideSegments !== "object" || edgeDistanceIn <= 0) return;

      const labels = Object.keys(sideSegments);
      if (labels.length === 0) return;

      // Exterior is consistently to the right of travel (clockwise path).
      const getExteriorNormal = (_label, dx, dy) => {
        const L = Math.hypot(dx, dy) || 1;
        const ux = dx / L;
        const uy = dy / L;
        return { x: -uy, y: ux }; // Right of travel direction
      };

      const getCornerFlags = (label) => Preview._cornerFlagsForShape(shape, label);

      // Draw offset line for each side where deductions occur
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i];
        const seg = sideSegments[label];
        if (!seg || !seg.p0 || !seg.p1) continue;

        const p0 = seg.p0;
        const p1 = seg.p1;
        const dx = p1.x - p0.x;
        const dy = p1.y - p0.y;
        const L = Math.hypot(dx, dy) || 1;
        const ux = dx / L;
        const uy = dy / L;
        const exterior = getExteriorNormal(label, dx, dy);
        const flags = getCornerFlags(label);

        // Skip if no deductions on this side
        if (!flags.cornerAtStart && !flags.cornerAtEnd) continue;

        // Calculate start and end points of the offset line (raw length = full length)
        // The grey line represents the raw length input by user
        let lineStart = p0;
        let lineEnd = p1;

        // Adjust start/end only where deductions apply (raw extends beyond effective)
        if (flags.cornerAtStart) {
          lineStart = { x: p0.x - ux * edgeDistanceIn, y: p0.y - uy * edgeDistanceIn };
        }
        if (flags.cornerAtEnd) {
          lineEnd = { x: p1.x + ux * edgeDistanceIn, y: p1.y + uy * edgeDistanceIn };
        }

        // Offset the line outward (toward exterior) by half the stroke width
        // The stroke-width will be edgeDistanceIn, so we offset by edgeDistanceIn/2
        const offsetX = exterior.x * (edgeDistanceIn / 2);
        const offsetY = exterior.y * (edgeDistanceIn / 2);

        const offsetLineStart = {
          x: lineStart.x + offsetX,
          y: lineStart.y + offsetY,
        };
        const offsetLineEnd = {
          x: lineEnd.x + offsetX,
          y: lineEnd.y + offsetY,
        };

        // Draw the offset line with stroke-width equal to the offset distance (in user units)
        const offsetLine = document.createElementNS("http://www.w3.org/2000/svg", "line");
        offsetLine.setAttribute("x1", String(offsetLineStart.x));
        offsetLine.setAttribute("y1", String(offsetLineStart.y));
        offsetLine.setAttribute("x2", String(offsetLineEnd.x));
        offsetLine.setAttribute("y2", String(offsetLineEnd.y));
        offsetLine.setAttribute("stroke", "#BBAF96");
        offsetLine.setAttribute("stroke-width", String(edgeDistanceIn)); // Direct user units (inches)
        offsetLine.setAttribute("stroke-linecap", "butt");
        svg.appendChild(offsetLine);
      }
    },

    _cornerFlagsForShape(shape, label) {
      switch (shape) {
        case "straight":
          return { cornerAtStart: false, cornerAtEnd: false };
        case "l_shape":
          if (label === "A") return { cornerAtStart: false, cornerAtEnd: true };
          if (label === "B") return { cornerAtStart: true, cornerAtEnd: false };
          return { cornerAtStart: false, cornerAtEnd: false };
        case "u_shape":
          if (label === "A") return { cornerAtStart: false, cornerAtEnd: true };
          if (label === "B") return { cornerAtStart: true, cornerAtEnd: true };
          if (label === "C") return { cornerAtStart: true, cornerAtEnd: false };
          return { cornerAtStart: false, cornerAtEnd: false };
        case "square":
          return { cornerAtStart: true, cornerAtEnd: true };
        case "open_3_corners":
          if (label === "A") return { cornerAtStart: false, cornerAtEnd: true };
          if (label === "B") return { cornerAtStart: true, cornerAtEnd: true };
          if (label === "C") return { cornerAtStart: true, cornerAtEnd: true };
          if (label === "D") return { cornerAtStart: true, cornerAtEnd: false };
          return { cornerAtStart: false, cornerAtEnd: false };
        default:
          return { cornerAtStart: false, cornerAtEnd: false };
      }
    },

    // Draws dimension lines: outside = raw length, inside = effective length.
    _drawDimensionLines(svg, { p0, p1, label, rawLengthIn, effectiveLengthIn, edgeDistanceIn, shape, sideIndex = 0, sideCount = 1 }) {
      const dx = p1.x - p0.x;
      const dy = p1.y - p0.y;
      const L = Math.hypot(dx, dy) || 1;
      const ux = dx / L;
      const uy = dy / L;
      const nx = -uy; // right normal (exterior)
      const ny = ux;

      const measureColor = "#687A65";
      const outPad = Preview._pxToUser(svg, 8);
      const inPad = Preview._pxToUser(svg, 12);
      const stagger = Preview._pxToUser(svg, (sideIndex % 2) * 12 + Math.floor(sideIndex / 2) * 4);
      const arrowSize = Preview._pxToUser(svg, 5);
      const textOutSize = 15;
      const textInSize = 15;
      const textOutOffset = Preview._pxToUser(svg, 12);
      const textInOffset = Preview._pxToUser(svg, 8);
      const arrowAngle = Math.atan2(dy, dx);

      const cornerFlags = Preview._cornerFlagsForShape(shape, label);
      const rawStart = cornerFlags.cornerAtStart ? { x: p0.x - ux * edgeDistanceIn, y: p0.y - uy * edgeDistanceIn } : p0;
      const rawEnd = cornerFlags.cornerAtEnd ? { x: p1.x + ux * edgeDistanceIn, y: p1.y + uy * edgeDistanceIn } : p1;

      const isVertical = Math.abs(dy) > Math.abs(dx);
      const isHorizontal = !isVertical;
      const horizontalNudgeY = (lbl) => {
        if (!isHorizontal) return 0;
        const n = Preview._pxToUser(svg, 12);
        if (lbl === "B") return -n; // move up
        if (lbl === "D") return n; // move down
        return 0;
      };
      const innerLineNudgeY = (lbl) => {
        if (!isHorizontal) return 0;
        const n = Preview._pxToUser(svg, 6);
        if (lbl === "B") return n; // move down
        if (lbl === "D") return -n; // move up
        return 0;
      };
      const innerTextNudgeY = (lbl) => {
        if (!isHorizontal) return 0;
        const n = Preview._pxToUser(svg, 6);
        if (lbl === "D") return n; // move down
        return 0;
      };
      const anchorFor = (textX, lineX) => {
        if (!isVertical) return "middle";
        if (textX < lineX - 1e-6) return "end";
        if (textX > lineX + 1e-6) return "start";
        return "middle";
      };

      if (Number.isFinite(rawLengthIn) && rawLengthIn > 0) {
        const outOffset = (edgeDistanceIn > 0 ? edgeDistanceIn : 0) + outPad + stagger;
        const dimStartBase = { x: rawStart.x + nx * outOffset, y: rawStart.y + ny * outOffset };
        const dimEndBase = { x: rawEnd.x + nx * outOffset, y: rawEnd.y + ny * outOffset };
        const nudgeY = horizontalNudgeY(label);
        const dimStart = { x: dimStartBase.x, y: dimStartBase.y + nudgeY };
        const dimEnd = { x: dimEndBase.x, y: dimEndBase.y + nudgeY };
        Preview.line(svg, { x1: dimStart.x, y1: dimStart.y, x2: dimEnd.x, y2: dimEnd.y, stroke: measureColor, widthPx: 1 });
        Preview._drawArrowhead(svg, dimStart, arrowAngle + Math.PI, arrowSize, measureColor);
        Preview._drawArrowhead(svg, dimEnd, arrowAngle, arrowSize, measureColor);
        const textMid = { x: (dimStartBase.x + dimEndBase.x) / 2, y: (dimStartBase.y + dimEndBase.y) / 2 };
        const line1 = label;
        const line2 = `${Preview._formatMeasure(rawLengthIn)}"`;
        const textX = textMid.x + nx * textOutOffset;
        const anchor = anchorFor(textX, dimStart.x);
        Preview.textLines(svg, {
          x: textX,
          y: textMid.y + ny * textOutOffset,
          lines: [line1, line2],
          sizePx: textOutSize,
          fill: measureColor,
          anchor,
        });
      }

      if (Number.isFinite(effectiveLengthIn) && effectiveLengthIn > 0) {
        const nudgeY = innerLineNudgeY(label);
        const dimStart = {
          x: p0.x - nx * (inPad + stagger * 0.4),
          y: p0.y - ny * (inPad + stagger * 0.4) + nudgeY,
        };
        const dimEnd = {
          x: p1.x - nx * (inPad + stagger * 0.4),
          y: p1.y - ny * (inPad + stagger * 0.4) + nudgeY,
        };
        Preview.line(svg, { x1: dimStart.x, y1: dimStart.y, x2: dimEnd.x, y2: dimEnd.y, stroke: measureColor, widthPx: 1 });
        Preview._drawArrowhead(svg, dimStart, arrowAngle + Math.PI, arrowSize, measureColor);
        Preview._drawArrowhead(svg, dimEnd, arrowAngle, arrowSize, measureColor);
        const textMid = { x: (dimStart.x + dimEnd.x) / 2, y: (dimStart.y + dimEnd.y) / 2 };
        const value = `${Preview._formatMeasure(effectiveLengthIn)}"`;
        const textX = textMid.x - nx * textInOffset;
        const anchor = anchorFor(textX, dimStart.x);
        const textNudgeY = innerTextNudgeY(label);
        Preview.text(svg, {
          x: textX,
          y: textMid.y - ny * textInOffset + textNudgeY,
          value,
          sizePx: textInSize,
          fill: measureColor,
          anchor,
        });
      }
    },

    // Draws an arrowhead at a point
    _drawArrowhead(svg, point, angle, size, fill = "#000") {
      const x1 = point.x - size * Math.cos(angle - 0.5);
      const y1 = point.y - size * Math.sin(angle - 0.5);
      const x2 = point.x - size * Math.cos(angle + 0.5);
      const y2 = point.y - size * Math.sin(angle + 0.5);

      const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
      path.setAttribute("d", `M ${point.x} ${point.y} L ${x1} ${y1} L ${x2} ${y2} Z`);
      path.setAttribute("fill", fill);
      path.setAttribute("stroke", "none");
      svg.appendChild(path);
    },

    // Draws corner offset indicators (orthogonal) showing the edge distance at corners.
    _drawCornerOffsets(svg, sideSegments, edgeDistanceIn) {
      const labels = Object.keys(sideSegments);
      if (labels.length < 2) return;

      for (let i = 0; i < labels.length - 1; i++) {
        const label1 = labels[i];
        const label2 = labels[i + 1];
        const seg1 = sideSegments[label1];
        const seg2 = sideSegments[label2];
        if (!seg1 || !seg2 || !seg1.p1 || !seg2.p0) continue;

        // Check if segments connect (corner)
        const corner = seg1.p1;
        const corner2 = seg2.p0;
        if (Math.abs(corner.x - corner2.x) > 1e-6 || Math.abs(corner.y - corner2.y) > 1e-6) continue;

        const dx1 = seg1.p1.x - seg1.p0.x;
        const dy1 = seg1.p1.y - seg1.p0.y;
        const L1 = Math.hypot(dx1, dy1) || 1;
        const ux1 = dx1 / L1;
        const uy1 = dy1 / L1;
        const nx1 = -uy1; // Right normal (exterior)
        const ny1 = ux1;

        const dx2 = seg2.p1.x - seg2.p0.x;
        const dy2 = seg2.p1.y - seg2.p0.y;
        const L2 = Math.hypot(dx2, dy2) || 1;
        const ux2 = dx2 / L2;
        const uy2 = dy2 / L2;
        const nx2 = -uy2; // Right normal (exterior)
        const ny2 = ux2;

        // Draw orthogonal offset lines (no diagonal)
        const base1 = { x: corner.x, y: corner.y };
        const end1 = { x: base1.x + nx1 * edgeDistanceIn, y: base1.y + ny1 * edgeDistanceIn };
        Preview.line(svg, { x1: base1.x, y1: base1.y, x2: end1.x, y2: end1.y, stroke: "#000", widthPx: 1 });

        const base2 = { x: corner.x, y: corner.y };
        const end2 = { x: base2.x + nx2 * edgeDistanceIn, y: base2.y + ny2 * edgeDistanceIn };
        Preview.line(svg, { x1: base2.x, y1: base2.y, x2: end2.x, y2: end2.y, stroke: "#000", widthPx: 1 });

        const textOffset = Preview._pxToUser(svg, 6);
        Preview.text(svg, {
          x: corner.x + (nx1 + nx2) * 0.5 * (edgeDistanceIn + textOffset),
          y: corner.y + (ny1 + ny2) * 0.5 * (edgeDistanceIn + textOffset),
          value: `${Preview._formatMeasure(edgeDistanceIn)}"`,
          sizePx: 12,
        });
      }
    },
    _formatMeasure(value) {
      if (!Number.isFinite(value)) return "";
      const s = String(value);
      return s.includes(".") ? s.replace(/0+$/, "").replace(/\.$/, "") : s;
    },
  };

  window.Cfg.Preview = Preview;
})();

